module.exports = __webpack_public_path__ + "static/media/collage-fox-small.2c6ef081.gif";